const initialState = {
  isData: false,
  tipoVehiculo: [],
  selTipoVehiculo: null,
  pagination: null,
};

const initialTipoVehiculoState = {
  selTipoVehiculo: null,
};

export const tipoVehiculo = (state = initialState, action) => {
  switch (action.type) {
    case 'setTipoVehiculo': {
      if (action.value.status === 200) {
        const stateData = { tipoVehiculo: action.value.data, isData: true, pagination: action.value.pagination };
        return { ...state, ...stateData };
      } else {
        return initialState;
      }
    }
    case 'setTipoVehiculoInit': {
      return initialState;
    }
    case 'setSelTipoVehiculo': {
      const obj = {
        ...action.value,
      };

      const stateData = { selTipoVehiculo: obj };

      return { ...state, ...stateData };
    }
    case 'setSelTipoVehiculoInit': {
      return { ...state, ...initialTipoVehiculoState };
    }

    default:
      //
      return state;
  }
};
